interface ICardProps {
  children: React.ReactNode;
  title?: string;
  style?: any;
  className?: string;
  [key:string]:any
}

export const Card: React.FC<ICardProps> = ({
  children,
  title,
  style,
  className = 'mobile:p-5',
  ...rest
}) => {
  return (
    <div
      {...rest}
      className={`rounded-2xl bg-bg p-[30px] mobile:rounded-lg font-500 ${className}`}
      style={style}
    >
      {title && (
        <h3 className="text-2xl text-primary leading-[34px] mb-[30px]">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};
